import React, { Component } from 'react';
import * as clipboard from 'clipboard-polyfill';
import PropTypes from 'prop-types';
import AlertBox from './AlertBox';

export default class LinkCopyButton extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);

    this.triggerRef = React.createRef();
    this.state = { clicked: false };
  }

  handleClick = () => {
    clipboard.writeText(this.props.url);
    this.setState({ clicked: true }, () => {
      setTimeout(() => {
        this.setState({ clicked: false });
      }, 5500);
    });
  };

  dismissHandle = () => {
    this.setState({ clicked: false });
  }

  render() {
    return (
      <div>
        <button onClick={this.handleClick} type="button" className="Button">
          <i className="Icon Icon-link u-mr-0" />
        </button>
        {this.state.clicked && (
          <AlertBox message={`A link to ${this.props.name} has been copied!`} onClick={this.dismissHandle} autoHide dismissable />
        )}
      </div>
    );
  }
}
